// extracted by mini-css-extract-plugin
export default {"liability_info":"ProductNutritionalInfo_liability_info__MzVlh","headline":"ProductNutritionalInfo_headline__6Rw2S","table":"ProductNutritionalInfo_table__0n2CX"};